export const isKeyOf = <T>(obj: T, key: string | keyof T): key is keyof T => {
  if (obj === null) {
    return false;
  } else if (typeof obj !== 'object') {
    return false;
  }

  return key in obj;
};
